class Invalid {
  constructor(reason, explanation) {
    this.reason = reason;
    this.explanation = explanation;
    this._formattedExplanation = "";
    explanation && (this._formattedExplanation = `: ${explanation}`);
  }
  toMessage() {
    return `${this.reason}${this._formattedExplanation}`;
  }
}
export {
  Invalid
};
